define('view/module/cart/CartPackageLinkView',['require','lib/view/LayoutView','lib/Utils','view/controller/booking/details/BookingLeaveConfirmationView','lib/view/ModalRegion','lib/Navigation','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    var BookingLeaveConfirmationView = require('view/controller/booking/details/BookingLeaveConfirmationView');
    var ModalRegion = require('lib/view/ModalRegion');
    var Navigation = require('lib/Navigation');

    var Config = require('Config');

    return LayoutView.extend({

        template: '#cart_module_package_link_view',

        ui: {
            'confirmLink': '.sb-confirm-leave a'
        },
    
        events: {
            'click @ui.confirmLink': 'confirmLinkClick',
        },

        modelEvents: {
            'sync': 'render',
            'change': 'render',
            'add:item': 'render',
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.call(this), {
                shouldShow: this.model.getQty() > 0,
                serviceIds: this.model.getServiceIds().join(','),
                productIds: this.model.getProductIds().join(',')
            });
        },

        confirmLinkClick: function (evt, params) {
            if (params && params.skipConfirmation) {
                return;
            }

            evt.preventDefault();
            evt.stopPropagation();
            
            var $target = $(evt.currentTarget);
            var link = $target.attr('href');
            
            var region = new ModalRegion();
            var view = new BookingLeaveConfirmationView();
            region.show(view);

            this.listenTo(view, 'confirm', function () {
                // NB on the link itself: jQuery does not run a native click on <a> (a child would follow the href)
                $target.trigger('click', {skipConfirmation: true})
                if (link) {
                    Navigation.go(link);
                }
            });
        }

    });

});
